import { Injectable } from '@angular/core';
import { AvisInitialService } from '../avisInitial/avis-initial.service';
import { DescriptionService } from '../description/description.service';

@Injectable({
  providedIn: 'root',
})
export class AnnulationService {
  constructor(public avisInitialService: AvisInitialService,
    public descriptionService: DescriptionService ) {}
}
